function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const Badge: React.FC<{
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}> = ({ className, children, onMouseEnter, onMouseLeave }) => {
  return (
    <span
      className={classNames(
        "text-black font-mono p-0.5 font-bold text-m",
        className || ""
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </span>
  );
};
